import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { Temario } from '../components/Temario';
import { Carousel } from '../components/Carousel';
import { Opinions } from '../components/Opinions';
import { Bonos } from '../components/Bonos';
import { Compra } from '../components/Compra';
import { Testimonials } from '../components/Testimonials';
import { Objections } from '../components/Objections';
import { Support } from '../components/Support';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { MetaPixel } from '../components/MetaPixel';
export function LandingPage() {
  const scrollToCompra = () => {
    const compraSection = document.getElementById('compra');
    if (compraSection) {
      compraSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white" data-id="element-170">
      <MetaPixel data-id="element-171" />
      <Hero onCTAClick={scrollToCompra} data-id="element-172" />
      <ProblemSection data-id="element-173" />
      <Temario data-id="element-174" />
      <Carousel onImageClick={scrollToCompra} data-id="element-175" />
      <Opinions data-id="element-176" />
      <Bonos onImageClick={scrollToCompra} data-id="element-177" />
      <Compra data-id="element-178" />
      <Testimonials data-id="element-179" />
      <Objections data-id="element-180" />
      <Support data-id="element-181" />
      <SocialProofPopup data-id="element-182" />
    </div>;
}